export class FrameLoadService {
  constructor($q) {
    this.$q = $q;
    this.frames = [];
  }

  addFrame(frame) {
    this.frames.push(frame);
  }

  removeFrame(frame) {
    this.frames = this.frames.filter(f => f !== frame);
  }

  get isReady() {
    return this.frames.every(frame => FrameLoadService.frameIsReady(frame));
  }

  waitUntilLoad() {
    return this.$q((resolve, reject) => {
      const check = () => {
        setTimeout(() => {
          if (this.isReady) {
            return resolve();
          }
          check();
        }, 1000);
      };
      check();
    });
  }

  static frameIsReady(frame) {
    // Check if loading is complete
    // This would fail if it is on a different domain
    // const document = frame.contentDocument || frame.contentWindow.document;
    // return !!(document && document.readyState === 'complete');
    return !!frame.getAttribute('sc-loaded');
  }
}



// WEBPACK FOOTER //
// ./src/core/frame-load.service.js